import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import chatService from '../../../api/services'

import { GenerateChatMediaUploadUrlDtoMediaType } from '@/schema'

type MediaType = 'image' | 'video' | 'audio' | 'file'

interface UploadChatMediaParams {
	file: File
	mediaType: MediaType
}

interface UploadChatMediaResult {
	fileUrl: string
}

const mediaTypeMap: Record<MediaType, GenerateChatMediaUploadUrlDtoMediaType> =
	{
		image: GenerateChatMediaUploadUrlDtoMediaType.image,
		video: GenerateChatMediaUploadUrlDtoMediaType.video,
		audio: GenerateChatMediaUploadUrlDtoMediaType.audio,
		file: GenerateChatMediaUploadUrlDtoMediaType.file,
	}

export function useMutationUploadChatMedia() {
	return useMutation({
		mutationFn: async ({
			file,
			mediaType,
		}: UploadChatMediaParams): Promise<UploadChatMediaResult> => {
			// Get file extension
			const fileExtension = file.name.split('.').pop()?.toLowerCase() || 'bin'

			// Generate presigned URL
			const { presignedUrl, fileUrl } =
				await chatService.generateMediaUploadUrl({
					mediaType: mediaTypeMap[mediaType],
					fileExtension,
				})

			// Upload file to presigned URL
			await chatService.uploadFileToPresignedUrl(presignedUrl, file)

			return { fileUrl }
		},
		onError: () => {
			toast.error('อัพโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง')
		},
	})
}
